import styled from 'styled-components';
import {
  Form,
} from 'antd';
import { COLOR_WHITE } from 'constants/colors';
import { Button } from 'UI';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    // max-width: 376px;
  }
`;

export const InlineFormGroup = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;

    &-input-content {
      display: flex;

      & ${BaseFormItem.toString()} {
        padding-bottom: 0;
        max-width: 376px;

        &:first-child {
          margin-right: 1.5rem;
        }
      }
    }
  }
`;

export const AddressInline = styled(InlineFormGroup)`
  & .state-input {
    max-width: 128px;
    width: auto;
  }
`;

export const NotesInline = styled(BaseFormItem)`
  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 100%;
  }
`;

export const InlineButton = styled(Button)`
  display: inline-flex;
  width: auto;
`;
